import SpbTopActions from './SpbTopActions.component';

export default SpbTopActions;